<script lang="ts">
  import Typography from "$lib/components/Typography/Typography.svelte";
  import Flag from "$lib/components/Flag/Flag.svelte";

  export let label = "";
  export let countryCode = "";
  export let section = "";

  export let selected: boolean = false;

  export let highlighted: boolean = false;

  let self: HTMLDivElement;
  $: if (self && highlighted) {
    self.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
    });
  }
</script>

<style lang="scss">
  .dropdown {
    &--section-title {
      color: $on-surface-30;
      display: flex;
      align-items: center;
      padding: 13px 16px;
      text-transform: capitalize;
      background-color: $on-surface-10;
    }
    &--item {
      display: flex;
      align-items: center;
      padding: 13px 16px;
      cursor: pointer;
      text-transform: capitalize;

      &:hover {
        background-color: $on-surface-5;
      }

      &__highlighted {
        background-color: $on-surface-5;
      }
    }
    &--flag {
      font-size: 20px;
      margin-right: 8px;
    }
  }
</style>

{#if section}
  <div class="dropdown--section-title">
    <Typography component="span" variant="overline" theme="on-background">
      {section}
    </Typography>
  </div>
{/if}

<div
  bind:this={self}
  class={`dropdown--item${highlighted ? " dropdown--item__highlighted" : ""}`}
  on:click
  on:keydown
  role="option"
  tabindex="0"
  aria-selected={selected ? "true" : "false"}
>
  {#if label && countryCode}
    <div class="dropdown--flag">
      <Flag {countryCode} country={label} />
    </div>
  {/if}
  <Typography component="span" theme="on-background">
    {label}
  </Typography>
</div>
